"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transformer = void 0;
const index_1 = require("./index");
const configurable_1 = require("../configurable");
class Transformer extends configurable_1.Configurable {
    transform(data) {
        return this.performTransform(data);
    }
    static create(type, options) {
        try {
            switch (type) {
                case 'simple':
                    return new index_1.SimpleTransformer(options);
                default:
                    throw new configurable_1.InvalidConfigurationException({ type: 'invalid' });
            }
        }
        catch (e) {
            throw new configurable_1.InvalidConfigurationException(e.details.type ? e.details : { adapter: e.details });
        }
    }
}
exports.Transformer = Transformer;
//# sourceMappingURL=base-transformer.js.map